import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Button} from 'reactstrap';
import cx from "classnames";
import {useTranslation, Trans} from "react-i18next";
import cloneDeep from 'lodash/cloneDeep';

import {logoutRequestStart} from '../../../actions/Auth'
import {setEnableMobileMenuSmall} from '../../../actions/ThemeOptions'
import {updateCurrentShopAdministrator} from "../../../actions/Shops";
import {apiFormSubmitRequest} from "../../../thunks/ApiModel";
import {revokeFirebaseToken} from "../../../thunks/Notifications";
import get from "lodash/get";
import {SHOP_SOURCE_CHAT_API} from "../../../constants";


const API_PATH = 'shop/shop_administrators';


const UserBox = (
    {
        activeShop,
        firebaseToken,
        authUser,
        currentShopAdministrator,
        logoutRequestStart,
        setEnableMobileMenuSmall,
        apiFormSubmitRequest,
        updateCurrentShopAdministrator,
        revokeFirebaseToken,
    }
) => {
    const {t, i18n} = useTranslation();
    const isChatApi = get(activeShop, 'source') === SHOP_SOURCE_CHAT_API;
    const logout = () => {
        firebaseToken && revokeFirebaseToken(firebaseToken);
        setEnableMobileMenuSmall(false);
        setTimeout(() => logoutRequestStart(), 200);
    };

    /**
     * Toggle is_active
     */
    const actionToggleIsOnline = () => {
        const apiUrl = `${API_PATH}/${currentShopAdministrator.id}/`;
        const method = 'patch';
        const formData = {
            is_online: !currentShopAdministrator.is_online,
        };
        const callback = (response) => {
            const updatedData = cloneDeep(currentShopAdministrator);
            updatedData.is_online = !currentShopAdministrator.is_online;
            updateCurrentShopAdministrator(updatedData);
        };
        apiFormSubmitRequest(
            apiUrl,
            method,
            formData,
            undefined,
            callback,
        );
    };

    return (
        <Fragment>
            <div className="pr-0">
                <div className="widget-content p-0">
                    <div className="widget-content-wrapper">
                        {
                            currentShopAdministrator &&
                            <div className="widget-content-right mr-2 ml-4 d-flex align-items-center">
                                <div
                                    className="switch has-switch long-switch"
                                    data-on-label="ON"
                                    data-off-label="OFF"
                                    style={{top: 2}}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        actionToggleIsOnline();
                                    }}
                                >
                                    <div
                                        className={cx("switch-animate", {
                                            'switch-on': currentShopAdministrator.is_online,
                                            'switch-off': !currentShopAdministrator.is_online,
                                        })}
                                    >
                                        <input type="checkbox"/>
                                        <Trans i18nKey='layout.header.online_toggler_content'>
                                            <span className='switch-left bg-success'>Online</span>
                                            <label>&nbsp;</label>
                                            <span className="switch-right bg-success">Offline</span>
                                        </Trans>
                                    </div>
                                </div>
                            </div>
                        }
                        <div
                            className="widget-content-left ml-3 header-user-info text-left text-dark d-none d-sm-block">
                            <div className="widget-heading text-decoration-none">
                                {authUser.email}
                            </div>
                        </div>
                        {!isChatApi && <div className="widget-content-right mr-2 ml-4">
                            <Button className="btn-pill btn-shadow btn-shine" color="focus" onClick={() => {
                                logout()
                            }}>
                                {t('layout.header.button_logout', 'Logout')}
                            </Button>
                        </div>}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    authUser: state.Auth.user,
    firebaseToken: state.Notifications.firebaseToken,
    activeShop: state.Shops.activeShop,
    currentShopAdministrator: state.Shops.currentShopAdministrator,
});

const mapDispatchToProps = dispatch => ({
    logoutRequestStart: () => dispatch(logoutRequestStart()),
    revokeFirebaseToken: (firebaseToken, callback) => dispatch(revokeFirebaseToken(firebaseToken, callback)),
    setEnableMobileMenuSmall: (enabled) => dispatch(setEnableMobileMenuSmall(enabled)),
    apiFormSubmitRequest: (apiPath, method, formData, redirectUrl, callback) => dispatch(apiFormSubmitRequest(apiPath, method, formData, redirectUrl, callback)),
    updateCurrentShopAdministrator: (currentShopAdministrator) => dispatch(updateCurrentShopAdministrator(currentShopAdministrator)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserBox);
